module.exports = __webpack_public_path__ + "media/assets/images/connectors/easyvista-logo-310895d247bf1e955916fe171fb8d26f.png";